import React, { createContext, useState, useContext, useEffect } from 'react';

// Create a context to hold the theme state
const ThemeContext = createContext();

// Create a provider component that will wrap your application
export function ThemeProvider({ children }) {
  // State to hold the current theme, now defaulting to 'light'
  const [theme, setTheme] = useState('light');

  // Effect to apply the theme to the body element
  useEffect(() => {
    const body = window.document.body;
    body.setAttribute('data-theme', theme);
  }, [theme]);

  // Function to toggle between light and dark themes
  const toggleTheme = () => {
    setTheme(currentTheme => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Custom hook to easily access the theme context in any component
export function useTheme() {
  return useContext(ThemeContext);
}

